import { styled } from '@nykaa/ui-components';

export const Image = styled.div`
  width: 100%;
  aspect-ratio: 3/4;
  background-color: ${({ theme }) => theme.colors.surface20};
  margin-bottom: ${({ theme }) => theme.spacing.spacing100};
`;

export const Title = styled.div`
  width: 100%;
  height: 20px;
  background-color: ${({ theme }) => theme.colors.surface20};
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
`;

export const Subtitle = styled.div`
  width: 100%;
  height: 20px;
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
  background-color: ${({ theme }) => theme.colors.surface20};
`;

export const Pricing = styled.div`
  width: 100%;
  height: 20px;
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
  background-color: ${({ theme }) => theme.colors.surface20};
`;
